
import { Button } from "@/components/ui/button";
import { useLanguage } from "@/contexts/LanguageContext";
import { InfluencerGrid } from "./InfluencerGrid";
import { Influencer } from "@/types/influencer";
import { motion } from "framer-motion";

interface Category {
  id: string;
  name: string;
}

interface CategoryFilterProps {
  categories: Category[];
  activeCategory: string;
  onCategoryChange: (category: string) => void;
  filteredInfluencers: Influencer[];
}

export const CategoryFilter = ({ 
  categories, 
  activeCategory, 
  onCategoryChange, 
  filteredInfluencers 
}: CategoryFilterProps) => {
  const { language } = useLanguage();

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay: 0.4 }}
    >
      {/* Category Filter Buttons */}
      <div className="flex flex-wrap gap-3 justify-center mb-12">
        {categories.map((category) => (
          <Button
            key={category.id}
            variant={activeCategory === category.id ? "default" : "outline"}
            onClick={() => onCategoryChange(category.id)}
            className={`transition-all duration-300 ${
              activeCategory === category.id
                ? "bg-gradient-to-r from-primary to-secondary text-white shadow-lg scale-105"
                : "border-primary/20 text-primary hover:bg-primary/5 hover:border-primary/40"
            }`}
          >
            {category.name}
          </Button>
        ))}
      </div>

      {/* Influencer Grid */}
      <InfluencerGrid influencers={filteredInfluencers} />
    </motion.div>
  );
};
